var map = {
	"./CompoundDetails/CompoundDetails.js": "SYLH",
	"./CompoundDetails/CompoundDetailsText.js": "E0fW",
	"./CompoundDetails/styles.js": "25o9",
	"./FlowChart/FlowChart.js": "bDE3",
	"./FlowChart/styles.js": "XJVk",
	"./Hero/Hero.js": "VFZc",
	"./Hero/styles.js": "Gpqa",
	"./InfoRow/InfoRow.js": "UI/P",
	"./InfoRow/styles.js": "m6PM",
	"./Objective/Objective.js": "wlyb",
	"./Objective/styles.js": "89yf",
	"./Patent/Patent.js": "VO+a",
	"./Patent/styles.js": "9Lpc",
	"./PressReleaseDetails/PressReleaseDetails.js": "UUT1",
	"./PressReleaseDetails/styles.js": "4cX4",
	"./PressReleaseListing/PressReleaseListing.js": "vdQY",
	"./PressReleaseListing/styles.js": "GPA/",
	"./ResourceListing/ResourceListing.js": "02g0",
	"./ResourceListing/styles.js": "cZwX",
	"./RichTextArea/RichTextArea.js": "rAoC",
	"./RichTextArea/styles.js": "1wYe",
	"./ScienceElementsSelector/ScienceElementsSelector.js": "BW/4",
	"./ScienceElementsSelector/styles.js": "Spxn",
	"./Statistics/Statistics.js": "O/q9",
	"./Statistics/styles.js": "Edwv",
	"./Team/Card.js": "xfUf",
	"./Team/Team.js": "Xr5X",
	"./Team/styles.js": "zcHk",
	"./TradingViewChart/TradingViewChart.js": "mfet",
	"./TradingViewChart/styles.js": "xI7y",
	"./V2FormulationsListing/FormulationTextBlock.js": "2EeK",
	"./V2FormulationsListing/V2FormulationsListing.js": "rYp1",
	"./V2FormulationsListing/styles.js": "5xqI",
	"./WhyAion/WhyAion.js": "FN6E",
	"./WhyAion/styles.js": "rh/Q"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jmgy";